// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"labels_pageWrapper__3hNQM"};